var cov_19au0l2dw = function () {
  var path = "/Users/spana/SHEIN/shineout/src/TreeSelect/styles/index.ts",
      hash = "58476e4816717b08fce412ed8c7d212471eac080",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/TreeSelect/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var treeSelectLess = {};
import genaration from '../../utils/classname';
export var treeSelectClass = (cov_19au0l2dw.s[0]++, genaration(treeSelectLess, 'treeSelect'));